import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EditorialManager = () => {
  const [file, setFile] = useState(null);
  const [prelimsFile, setPrelimsFile] =
useState(null);
  const [youtubeUrl, setYoutubeUrl] = useState(""); // NEW
  const [title, setTitle] = useState(""); // NEW
  const [editorialDate,
setEditorialDate] =
useState(
  new Date()
    .toISOString()
    .split("T")[0]
);

  const [editorials, setEditorials] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [expanded, setExpanded] = useState({});
  const [editing, setEditing] = useState(null);

const [showEdit,
setShowEdit] =
useState(false);

const [editEditorialPdf,
setEditEditorialPdf] =
useState(null);

const [editPrelimsPdf,
setEditPrelimsPdf] =
useState(null);

const [removeEditorialPdf,
setRemoveEditorialPdf] =
useState(false);

const [removePrelimsPdf,
setRemovePrelimsPdf] =
useState(false);

  const token = JSON.parse(localStorage.getItem("user"))?.token;
  const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

  // Upload Editorial
  const handleUpload = async (e) => {
    e.preventDefault();

    // Editorial PDF is optional

    const formData =
new FormData();


// ======================
// Editorial PDF
// ======================

if (file) {
  formData.append(
    "editorialPdf",
    file
  );
}


// ======================
// Prelims Notes PDF
// ======================

if (prelimsFile) {

  formData.append(
    "prelimsNotesPdf",
    prelimsFile
  );

}


// ======================
// Upload Type
// ======================

formData.append(
  "uploadType",
  "editorial"
);


// ======================
// Metadata
// ======================

formData.append(
  "youtubeUrl",
  youtubeUrl
);

formData.append(
  "title",
  title
);

formData.append(
  "date",
  editorialDate
);

    try {
      await axios.post(
        `${API_BASE}/api/admin/editorials/upload?uploadType=editorial`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Editorial uploaded successfully");

      // Reset
      setFile(null);
      setPrelimsFile(null);
      setYoutubeUrl("");
      setTitle("");
      setEditorialDate(
  new Date()
    .toISOString()
    .split("T")[0]
);
      setRefresh(!refresh);

    } catch (err) {
      console.error(
"SAVE FAILED",
err.response?.data
||
err
);

alert(
err.response?.data?.message
||
"Failed to update"
);
      toast.error("Upload failed");
    }
  };

  // Fetch Editorials
  const fetchEditorials = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/admin/editorials`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setEditorials(res.data);
    } catch (err) {
      toast.error("Failed to fetch editorials");
    }
  };

  useEffect(() => {
    fetchEditorials();
  }, [refresh]);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this editorial?")) return;

    try {
      await axios.delete(`${API_BASE}/api/admin/editorials/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Deleted successfully");
      setRefresh(!refresh);
    } catch (err) {
      toast.error("Failed to delete");
    }
  };

  // Group editorials
  const groupByDate = () => {
    const grouped = {};

    editorials.forEach((e) => {
      const dateObj = new Date(e.date);
      const year = dateObj.getFullYear();
      const month = dateObj.toLocaleString("default", { month: "long" });
      const day = String(dateObj.getDate()).padStart(2, "0");

      if (!grouped[year]) grouped[year] = {};
      if (!grouped[year][month]) grouped[year][month] = {};
      if (!grouped[year][month][day]) grouped[year][month][day] = [];

      grouped[year][month][day].push(e);
    });

    return grouped;
  };

  const toggleExpand = (key) =>
    setExpanded((prev) => ({ ...prev, [key]: !prev[key] }));

  const groupedEditorials = groupByDate();

  const openEdit = (item) => {

setEditing({

...item,

youtubeUrl:
item.youtubeVideoId
? `https://youtube.com/watch?v=${item.youtubeVideoId}`
: ""

});

setEditEditorialPdf(null);

setEditPrelimsPdf(null);

setRemoveEditorialPdf(false);

setRemovePrelimsPdf(false);

setShowEdit(true);

};

  return (
    <div className="p-6 space-y-8">
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Upload Form */}
      <div
className="
relative
overflow-hidden
rounded-3xl
border
border-gray-200
dark:border-gray-600
bg-white/80
dark:bg-[#111827]
backdrop-blur-xl
shadow-[0_20px_80px_rgba(0,0,0,.08)]
dark:shadow-[0_20px_80px_rgba(0,0,0,.45)]
p-8
"
>
        <div className="mb-8">

<h2
className="
text-3xl
font-black
bg-gradient-to-r
from-blue-600
to-purple-600
bg-clip-text
text-transparent
"
>
📰 The Hindu Analysis
</h2>

<p className="text-gray-500 dark:text-gray-400 mt-2">
Daily Editorial + Prelims Notes
</p>

</div>

        <form
onSubmit={handleUpload}
className="
grid
md:grid-cols-2
gap-6
"
>

          {/* Title */}
          <div>

<label className="
mb-2
block
font-semibold
text-gray-800
dark:text-gray-100
">
Title
</label>

<input
type="text"
placeholder="Today's Editorial"

value={title}

onChange={(e)=>
setTitle(e.target.value)
}

className="
w-full
rounded-2xl
border
border-gray-300
dark:border-gray-500
bg-gray-50
dark:bg-[#1f2937]
dark:text-white
placeholder:text-gray-400
dark:placeholder:text-gray-500
p-4
outline-none
focus:ring-4
focus:ring-blue-500/20
"
/>

</div>

          {/* Editorial Date */}
<div>

<label className="
mb-2
block
font-semibold
text-gray-800
dark:text-gray-100
">

📅 Editorial Date

</label>

<input
type="date"

value={editorialDate}

onChange={(e)=>
setEditorialDate(
e.target.value
)
}

className="
w-full
rounded-2xl
border
border-gray-300
dark:border-gray-500
bg-gray-50
dark:bg-[#1f2937]
dark:text-white
placeholder:text-gray-400
dark:placeholder:text-gray-500
p-4
focus:ring-4
focus:ring-purple-500/20
"
/>

<p className="mt-2 text-sm text-gray-500">
Choose any missed day
</p>

</div>

          {/* YouTube URL */}
          <div className="md:col-span-2">

<label className="
mb-2
block
font-semibold
text-gray-800
dark:text-gray-100
">

🎥 Editorial Video

</label>

<input
type="text"

placeholder="Paste YouTube URL"

value={youtubeUrl}

onChange={(e)=>
setYoutubeUrl(
e.target.value
)
}

className="
w-full
rounded-2xl
border
border-gray-300
dark:border-gray-500
bg-gray-50
dark:bg-[#1f2937]
dark:text-white
placeholder:text-gray-400
dark:placeholder:text-gray-500
p-4
"
/>

</div>

{/* ================= PDF Upload ================= */}

<div className="md:col-span-1">

<label
className="
mb-2
block
font-semibold
text-gray-800
dark:text-gray-100
"
>

📄 Upload Editorial PDF
<span className="text-sm font-normal text-gray-500">
  (Optional)
</span>

</label>

<label
className="
flex
flex-col
items-center
justify-center
border-2
border-dashed
border-blue-300
dark:border-blue-500
rounded-3xl
p-10
cursor-pointer
hover:bg-blue-50
dark:hover:bg-[#243244]
dark:text-white
transition
"
>

<input
hidden
type="file"
accept="application/pdf"

onChange={(e)=>
setFile(
e.target.files[0]
)
}
/>

<div className="text-5xl mb-3">
📄
</div>

<div>

{
file
? file.name
: "Upload Editorial PDF (Optional)"
}

</div>

</label>

</div>





<div className="md:col-span-1">

<label
className="
mb-2
block
font-semibold
text-gray-800
dark:text-gray-100
"
>

📘 Upload Prelims Notes PDF
(Optional)

</label>

<label
className="
flex
flex-col
items-center
justify-center
border-2
border-dashed
border-green-300
dark:border-green-500
rounded-3xl
p-10
cursor-pointer
hover:bg-green-50
dark:hover:bg-[#243244]
dark:text-white
transition
"
>

<input
hidden
type="file"
accept="application/pdf"

onChange={(e)=>
setPrelimsFile(
e.target.files[0]
)
}
/>

<div className="text-5xl mb-3">
📘
</div>

<div>

{
prelimsFile
? prelimsFile.name
: "Upload Prelims Notes PDF"
}

</div>

</label>

</div>

<button
className="
md:col-span-2
rounded-2xl
bg-gradient-to-r
from-blue-600
to-purple-600
hover:scale-[1.02]
text-white
font-bold
py-4
transition
"
>

🚀 Upload Editorial

</button>
        </form>
      </div>

      {/* Editorial List */}
      <div className="space-y-4">
        <h3 className="text-2xl font-bold text-gray-800 dark:text-gray-100">
          Uploaded Editorials
        </h3>

        {Object.keys(groupedEditorials).length === 0 ? (
          <div
className="
rounded-3xl
text-center
p-12
bg-gray-50
dark:bg-[#111827]
dark:text-white
"
>

<div className="text-6xl">
📰
</div>

<p className="mt-4">

No editorials uploaded yet

</p>

</div>
        ) : (
          Object.entries(groupedEditorials)
            .sort((a, b) => b[0] - a[0])
            .map(([year, months]) => (
              <div
key={year}
className="
rounded-3xl
bg-white
dark:bg-[#111827]
dark:text-white
border
dark:border-gray-600
p-6
shadow-lg
"
>
                <button onClick={() => toggleExpand(`year-${year}`)}>
                  {year} {expanded[`year-${year}`] ? "▼" : "▶"}
                </button>

                {expanded[`year-${year}`] &&
                  Object.entries(months).map(([month, days]) => (
                    <div key={month} className="ml-6">
                      <button onClick={() => toggleExpand(`month-${month}`)}>
                        {month} {expanded[`month-${month}`] ? "▼" : "▶"}
                      </button>

                      {expanded[`month-${month}`] &&
                        Object.entries(days).map(([day, items]) => (
                          <div key={day} className="ml-6">
                            <button onClick={() => toggleExpand(`day-${day}`)}>
                              {day} {expanded[`day-${day}`] ? "▼" : "▶"}
                            </button>

                            {expanded[`day-${day}`] && (
                              <ul className="ml-4">
                                {items.map((item) => (
                                  <li
key={item._id}

className="
rounded-3xl
border
dark:border-gray-700
p-5
mb-4
bg-gray-50
dark:bg-[#172033]
"
>

<div className="space-y-3">

<h4 className="font-bold text-lg">
{item.title || "The Hindu Analysis"}
</h4>

<p className="text-sm opacity-70">

{new Date(
item.date
).toDateString()}

</p>

<div className="flex gap-3 flex-wrap">

{item.editorialPdfUrl && (

<a
href={item.editorialPdfUrl}
target="_blank"
rel="noreferrer"

className="
px-4
py-2
rounded-xl
bg-blue-600
text-white
"
>

📄 Editorial

</a>

)}

{item.prelimsNotesPdfUrl && (

<a
href={item.prelimsNotesPdfUrl}
target="_blank"

rel="noreferrer"

className="
px-4
py-2
rounded-xl
bg-green-600
text-white
"
>

📘 Notes

</a>

)}

</div>

<div className="flex gap-3">

<button

onClick={()=>
openEdit(item)
}

className="
px-4
py-2
rounded-xl
bg-yellow-500
text-white
"
>

✏ Edit

</button>


<button

onClick={()=>
handleDelete(
item._id
)
}

className="
px-4
py-2
rounded-xl
bg-red-500
text-white
"
>

Delete

</button>

</div>

</div>

</li>
                                ))}
                              </ul>
                            )}
                          </div>
                        ))}
                    </div>
                  ))}
              </div>
            ))
        )}
      </div>
      {showEdit && editing && (

<div
className="
fixed
inset-0
z-50
bg-black/60
flex
justify-center
items-center
"
>

<div
className="
bg-white
dark:bg-[#111827]
rounded-3xl
p-8
w-[700px]
space-y-5
"
>

<h2 className="text-2xl font-bold">

Edit Analysis

</h2>

<input
value={
editing.title
}

onChange={(e)=>

setEditing({

...editing,

title:
e.target.value

})

}

className="
w-full
border
p-4
rounded
"
/>

<input
value={
editing.youtubeUrl
}

onChange={(e)=>

setEditing({

...editing,

youtubeUrl:
e.target.value

})

}

className="
w-full
border
p-4
rounded
"
/>

<input
type="date"

value={
editing.date
?.split("T")[0]
}

onChange={(e)=>

setEditing({

...editing,

date:
e.target.value

})

}

className="
w-full
border
p-4
rounded
"
/>
{/* ================= Editorial PDF ================= */}

<div>

<p className="font-semibold mb-2">

📄 Editorial PDF

</p>

<div className="flex gap-3 flex-wrap">

{editing.editorialPdfUrl && (

<a
href={editing.editorialPdfUrl}
target="_blank"
rel="noreferrer"

className="
px-4
py-2
bg-blue-600
text-white
rounded-xl
"
>

View Current

</a>

)}

<label
className="
px-4
py-2
bg-green-600
text-white
rounded-xl
cursor-pointer
"
>

Replace

<input
hidden
type="file"

accept="application/pdf"

onChange={(e)=>

setEditEditorialPdf(
e.target.files[0]
)

}
/>

</label>

<button

type="button"

onClick={()=>

setRemoveEditorialPdf(
(v)=>!v
)

}

className="
px-4
py-2
bg-red-500
text-white
rounded-xl
"
>

{
removeEditorialPdf
? "Undo Delete"
: "Delete"
}

</button>

</div>

{
editEditorialPdf && (

<p className="text-sm">

New:
{
editEditorialPdf.name
}

</p>

)

}

</div>



{/* ================= Prelims PDF ================= */}

<div>

<p className="font-semibold mb-2">

📘 Prelims Notes

</p>

<div className="flex gap-3 flex-wrap">

{editing.prelimsNotesPdfUrl && (

<a
href={
editing.prelimsNotesPdfUrl
}

target="_blank"

rel="noreferrer"

className="
px-4
py-2
bg-green-600
text-white
rounded-xl
"
>

View Current

</a>

)}

<label
className="
px-4
py-2
bg-blue-600
text-white
rounded-xl
cursor-pointer
"
>

Replace

<input
hidden
type="file"

accept="application/pdf"

onChange={(e)=>

setEditPrelimsPdf(
e.target.files[0]
)

}
/>

</label>

<button

type="button"

onClick={()=>

setRemovePrelimsPdf(
(v)=>!v
)

}

className="
px-4
py-2
bg-red-500
text-white
rounded-xl
"
>

{
removePrelimsPdf
? "Undo Delete"
: "Delete"
}

</button>

</div>

{
editPrelimsPdf && (

<p className="text-sm">

New:
{
editPrelimsPdf.name
}

</p>

)

}

</div>

<div className="flex gap-3">

<button

onClick={
async () => {

try {

console.log("SAVE CLICKED");

const fd =
new FormData();

fd.append(
"title",
editing.title
);

fd.append(
"youtubeUrl",
editing.youtubeUrl
);

fd.append(
"date",
editing.date
);

fd.append(
"removeEditorialPdf",
removeEditorialPdf
);

fd.append(
"removePrelimsPdf",
removePrelimsPdf
);

if (
editEditorialPdf
) {

fd.append(
"editorialPdf",
editEditorialPdf
);

}

if (
editPrelimsPdf
) {

fd.append(
"prelimsNotesPdf",
editPrelimsPdf
);

}

await axios.put(

`${API_BASE}/api/admin/editorials/${editing._id}`,

fd,

{
headers:{

Authorization:
`Bearer ${token}`,

"Content-Type":
"multipart/form-data"

}

}

);

console.log(
"UPDATE SUCCESS"
);

await fetchEditorials();

setEditing(null);

setShowEdit(false);

setEditEditorialPdf(null);

setEditPrelimsPdf(null);

setRemoveEditorialPdf(false);

setRemovePrelimsPdf(false);

setShowEdit(
false
);

}
catch(
err
){

console.error(
err
);

}

}

}

className="
bg-blue-600
text-white
px-5
py-3
rounded
"
>

Save

</button>

<button

onClick={()=>
setShowEdit(
false
)
}

className="
bg-gray-500
text-white
px-5
py-3
rounded
"
>

Cancel

</button>

</div>

</div>

</div>

)}
    </div>
  );
};

export default EditorialManager;